/**
 * 诊室模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取诊室列表
export const clinicList = (params) => {
  return req.get('/system/clinic/list', params);
}

// 新增诊室
export const clinicAdd = (params) => {
  return req.post('/system/clinic', params);
}

// 修改诊室信息
export const clinicEdit = (params) => {
  return req.put('/system/clinic', params);
}